<template>
    <div class="x_app">
        <div class="x_body">
            <div class="card f_card no-bor">
                <div class="card-body">
                    <div class="animated fadeIn">
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
                                <div class="card card-sum">
                                    <div class="card-body pb-0">
                                        <h4 class="mb-0">{{$money(totalQuotation)}}</h4>
                                        <p>{{$t("total")}} {{$t("sale_quotation")}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
                                <div class="card card-sum">
                                    <div class="card-body pb-0">
                                        <h4 class="mb-0">{{$money(totalOrder)}}</h4>
                                        <p>{{$t("total")}} {{$t("sale_order")}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
                                <div class="card card-sum">
                                    <div class="card-body pb-0">
                                        <h4 class="mb-0">{{$money(totalInvoice)}}</h4>
                                        <p>{{$t("total")}} {{$t("sale_invoice")}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
                                <div class="card card-sum">
                                    <div class="card-body pb-0">
                                        <h4 class="mb-0">{{$money(totalReceipt)}}</h4>
                                        <p>{{$t("total")}} {{$t("sale_receipt")}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
                                <div class="card card-sum">
                                    <div class="card-body pb-0">
                                        <h4 class="mb-0">{{$number(totalCustomer)}}</h4>
                                        <p>{{$t("total")}} {{$t("customer")}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
                                <div class="card card-sum">
                                    <div class="card-body pb-0">
                                        <h4 class="mb-0">{{$money(totalAR)}}</h4>
                                        <p>{{$t("total")}} {{$t("ar")}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <b-row>
                            <b-col sm="12" lg="12">
                                <div class="x_body vld-parent" ref="load100">
                                    <div class="card x_card">
                                        <div class="card-header">
                                            <i class="fa fa-bar-chart" aria-hidden="true"></i> {{$t("statistic_sale_per_months")}} {{$t('month_' + month)}}/{{year}}
                                            <div class="pull-right">
                                                <select class="form-control form-control-sm" v-model="month">
                                                    <option v-for="n in 12" :value="n" :key="n">{{$t('month_' + n)}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <SalePerMonthBarChart :month="month" />
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SalePerMonthBarChart from "../Chart/SalePerMonthBarChart";
export default {
    components: {
        SalePerMonthBarChart
    },
    data(){
        return{
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear(),
            totalQuotation: 0,
            totalOrder: 0,
            totalInvoice: 0,
            totalReceipt: 0,
            totalCustomer: 0,
            totalAR: 0,
        }
    },
    created(){
        this.getSummary();
    },
    methods: {
        getSummary(){
            var loading = this.$loading.show();
            this.$api().post('sale-dashboard/summaries', { CompanyId: this.$store.state.company.Id }).then(res => {
                if(this.$isValid(res)){
                    this.totalQuotation = res.data.Json.TotalQuotation;
                    this.totalOrder = res.data.Json.TotalOrder;
                    this.totalInvoice = res.data.Json.TotalInvoice;
                    this.totalReceipt = res.data.Json.TotalReceipt;
                    this.totalCustomer = res.data.Json.TotalCustomer;
                    this.totalAR = res.data.Json.TotalAR;
                }
            }).finally(function(){ loading.hide(); });
        }
    }
}
</script>
<style scoped>
    .card-sum{
        border: 1px dashed #00406B;
        color: #0856ab;
        text-transform: uppercase;
    }
</style>